<template>
    <div v-if="grade !== null">
        <span :class="badgeClass">{{formattedGrade}}</span>
    </div>
</template>

<script>
export default {
    name: 'EvaluationGrade',

    props: {
        grade: {
            type: Number,
            required: true
        },
        approved: {
            type: Boolean,
            required: false,
            default: undefined
        }
    },

    computed: {
        formattedGrade() {
            return Number(this.grade).toFixed(2)
        },
        badgeClass() {
            return (this.approved ?? (this.grade === 100)) // Fallback while we have no approved field
                ? 'badge bg-success bg-opacity-75' 
                : 'badge bg-secondary bg-opacity-50'
        }
    }
}
</script>